import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PaymentItem } from './payment-item.model';
import { PaymentItemService } from './payment-item.service';
import { Payment, PaymentService } from '../payment';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class PaymentItemPopupService {
    private isOpen = false;
    constructor(
        private modalService: NgbModal,
        private paymentService: PaymentService,
        private router: Router,
        private paymentItemService: PaymentItemService
    ) { }

    open(component: Component, id: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        this.paymentItemService.find(id)
        .subscribe(paymentItem => {
            this.paymentItemModalRef(component, paymentItem);
        }, (error: HttpErrorResponse) => {
            this.isOpen = false;
        });
    }

    openCreate(component: Component, idPaiment?: number): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        this.paymentService.find(idPaiment)
        .subscribe(payment => {
            const paymentItem = new PaymentItem();
            paymentItem.payment = payment;
            paymentItem.beneficiary = payment.payer;
            this.paymentItemModalRef(component, paymentItem);
        });
    }

    paymentItemModalRef(component: Component, paymentItem: PaymentItem): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.paymentItem = paymentItem;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment-item/payment-item-popup.service.ts